const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const extractNonResourcefulPathname = (pathname: string) => {
  const segments = pathname.split("/").filter(Boolean);

  const uuidSegmentIndex = segments.findIndex((segment) => uuidRegex.test(segment));
  if (uuidSegmentIndex === -1) {
    return pathname;
  }

  return `/${segments.slice(0, uuidSegmentIndex).join("/")}`;
};
